import { Breadcrumb } from 'antd'
import { useLocation } from 'react-router-dom'

const routes: Record<string, string> = {
  '/profile': 'Trang cá nhân',
  '/dashboard': 'Dashboard',
  '/dashboard/dau-noi': 'Đấu nối',
  '/dashboard/gia-han': 'Gia hạn',
  '/dau-noi': 'Đấu nối',
  '/top-up': 'Quản lý nạp tiền',
  '/top-up/overview': 'Tổng quan',
  '/top-up/order': 'Đơn hàng',
  '/top-up/history': 'Lịch sử giao dịch',
  '/top-up/detail-transaction': 'Chi tiết giao dịch',
  '/api-package': 'Quản lý API gói',
  '/api-package/overview': 'Tổng quan',
  '/api-package/order': 'Đơn hàng',
  '/api-package/history': 'Lịch sử giao dịch',
  '/api-package/detail-transaction': 'Chi tiết giao dịch',
  '/api-package/detail-package': 'Danh sách gói cước',
  '/register-addon': 'Quản lý data sponsor',
  '/register-addon/overview': 'Tổng quan',
  '/register-addon/order': 'Đơn hàng',
  '/register-addon/history': 'Lịch sử giao dịch',
  '/register-addon/detail-transaction': 'Chi tiết giao dịch',
  '/register-addon/detail-package': 'Danh sách gói cước',
  '/kit-sim': 'Quản lý đấu nối',
  '/kit-sim/connect': 'Đấu nối',
  '/kit-sim/order': 'Lịch sử đấu nối',
  '/kit-sim/request': 'Yêu cầu đấu nối',
  '/kit-sim/history': 'Lịch sử',
  '/kit-sim/detail-transaction': 'Chi tiết',
  '/kit-order': 'Quản lý đấu lô',
  '/kit-order/connect': 'Đấu lô',
  '/kit-order/order': 'Lịch sử đấu lô',
  '/kit-order/order/detail': 'Chi tiết',
  '/invoice': 'Hóa đơn',
  '/invoice/create': 'Xuất hóa đơn',
  '/invoice/history': 'Danh sách hóa đơn',
  '/extension': 'Quản lý gia hạn',
  '/extension/customer': 'Khách hàng',
  '/extension/customer/detail': 'Chi tiết',
  '/extension/agency': 'Đại lý',
  '/extension/agency/detail': 'Chi tiết',
  '/extension/telesale': 'Gia hạn',
  '/import': 'Kho nhập',
  '/import/order': 'Đơn hàng',
  '/import/order/detail': 'Chi tiết',
  '/import/history': 'Kiểm tra Serial',
  '/export': 'Kho xuất',
  '/export/order': 'Đơn hàng',
  '/export/order/detail': 'Chi tiết',
  '/export/history': 'Kiểm tra Serial',
  '/overview': 'Tổng quan',
  '/sim-passport': 'Sim Passport',
  '/company': 'Công ty',
  '/company/detail': 'Chi tiết công ty',
  '/company/create': 'Thêm mới',
  '/company/update': 'Cập nhật',
  '/customer': 'khách hàng',
  '/customer/history': 'lịch sử',
  '/package': 'Quản lý gói cước',
  '/package/overview': 'Tổng quan',
  '/package/overview/create': 'Thêm mới',
  '/package/overview/update': 'Cập nhật',
  '/package/detail': 'Đối tác',
  '/package/detail/create': 'Thêm mới',
  '/package/detail/update': 'Cập nhật',
  '/telegram': 'Telegram',
  '/telegram/create': 'Thêm mới',
  '/telegram/update': 'Cập nhật',
  '/transaction': 'Giao dịch',
  '/transaction/create': 'Thêm mới',
  '/zalo-account': 'Quản lý zalo',
  '/zalo-account/accounts': 'Tài khoản Zalo',
  '/admin': 'Admin',
  '/admin/user': 'Quản trị viên',
  '/admin/user/create': 'Thêm mới',
  '/admin/user/update': 'Cập nhật',
  '/admin/role': 'Phân quyền',
  '/admin/role/create': 'Thêm mới',
  '/admin/role/update': 'Cập nhật',
  '/admin/config': 'Cấu hình',
}

const BreadcrumbItem = () => {
  const location = useLocation()

  const pathSnippets = location.pathname.split('/').filter((i) => i)
  const extraBreadcrumbItems = pathSnippets.map((str, index) => {
    const url = `/${pathSnippets.slice(0, index + 1).join('/')}`

    let breadcrumbName = ''
    Object.keys(routes).forEach((pattern) => {
      const regex = new RegExp(pattern)

      if (regex.test(url)) {
        breadcrumbName = routes[pattern]
      }
    })

    return {
      key: url,
      title: breadcrumbName,
    }
  })

  return <Breadcrumb items={extraBreadcrumbItems} />
}
export default BreadcrumbItem
